import PropTypes from 'prop-types'

const sectionShape = PropTypes.shape({
  sectionId: PropTypes.number,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
})

export const existingFeedbackShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  propertyDescriptionId: PropTypes.number.isRequired,
  feedbackData: PropTypes.shape({
    incorrectInformation: PropTypes.bool,
    missingImportantInformation: PropTypes.bool,
    doesNotReflectHotelWell: PropTypes.bool,
    otherComment: PropTypes.string,
  }).isRequired,
})

export const descriptionForReviewShape = PropTypes.shape({
  propertyDescription: PropTypes.shape({
    id: PropTypes.number.isRequired,
    giataId: PropTypes.number.isRequired,
    locale: PropTypes.string,
    version: PropTypes.number.isRequired,
    lastModified: PropTypes.string.isRequired,
    description: PropTypes.shape({
      sections: PropTypes.arrayOf(sectionShape).isRequired,
    }).isRequired,
  }).isRequired,
  existingFeedback: existingFeedbackShape,
})
